<template>
    <j-page>
        <div slot="table">
            <el-card shadow="hover">
                <label slot="header">通用台账混入</label>
                <el-divider content-position="left">src/components/JComponents/JPage/mixins/PageMixins.js</el-divider>
                台账页面基本混入，主要包含<span style="color: #409EFF;">基本组件引入、导出、搜索、重置、获取数据列表、更新分页、删除等</span>方法模板
                <el-divider content-position="left">src/components/JComponents/JPage/mixins/validator.js</el-divider>
                台账页面基本校验混入，包含<span style="color: #409EFF;">电话、邮箱、年龄、密码</span>校验规则
                <el-divider content-position="left">src/components/JComponents/JPage/mixins/PaginationMixins.js</el-divider>
                页面分页混入，主要包含<span style="color: #409EFF;">改变分页、切换分页数量限制</span>的方法
                <el-divider content-position="left">src/components/JComponents/JPage/mixins/DrawerMixins.js</el-divider>
                侧边抽屉混入，主要包含<span style="color: #409EFF;">通过侧边栏操作的添加、编辑、详情、保存、重置、提交校验等</span>方法
                <el-divider content-position="left">src/components/JComponents/JPage/mixins/DialogMixins.js</el-divider>
                弹窗混入，主要包含<span style="color: #409EFF;">通过弹窗操作的添加、编辑、详情、保存、重置、提交校验等</span>方法
                <el-divider content-position="left">src/components/JComponents/JPage/mixins/EchartsMixins.js</el-divider>
                图表混入，基于Echarts快速构建图表模块<span style="color: #409EFF;">内置多种图标option案例，自带样式按需使用</span>方法
            </el-card>

            <el-card shadow="hover">
                <label slot="header">PageMixins基础分页混入</label>
                <el-divider content-position="left">data节点描述 表格中包含（=）的参数可于其他混入参数重复，并非冗余，而是考虑多变的使用环境做的兼容处理，重复对象会被做合并属性处理</el-divider>
                <el-table border :data="PageDataTable">
                    <el-table-column prop="name" label="字段" width="200px" />
                    <el-table-column prop="desc" label="描述" />
                </el-table>
                <el-divider content-position="left">methods节点描述</el-divider>
                <el-table border :data="PageMethodsTable">
                    <el-table-column prop="name" label="字段" width="200px" />
                    <el-table-column prop="desc" label="描述" />
                </el-table>
            </el-card>

            <el-card shadow="hover">
                <label slot="header">PaginationMixins页码混入</label>
                <el-divider content-position="left">data节点描述 表格中包含（=）的参数可于其他混入参数重复，并非冗余，而是考虑多变的使用环境做的兼容处理，重复对象会被做合并属性处理</el-divider>
                <el-table border :data="PaginationDataTable">
                    <el-table-column prop="name" label="字段" width="200px" />
                    <el-table-column prop="desc" label="描述" />
                </el-table>
                <el-divider content-position="left">methods节点描述</el-divider>
                <el-table border :data="PaginationMethodsTable">
                    <el-table-column prop="name" label="字段" width="200px" />
                    <el-table-column prop="desc" label="描述" />
                </el-table>
            </el-card>

            <el-card shadow="hover">
                <label slot="header">DialogMixins弹窗混入</label>
                <el-divider content-position="left">data节点描述 表格中包含（=）的参数可于其他混入参数重复，并非冗余，而是考虑多变的使用环境做的兼容处理，重复对象会被做合并属性处理</el-divider>
                <el-table border :data="DialogDataTable">
                    <el-table-column prop="name" label="字段" width="200px" />
                    <el-table-column prop="desc" label="描述" />
                </el-table>
                <el-divider content-position="left">methods节点描述</el-divider>
                <el-table border :data="DialogMethodsTable">
                    <el-table-column prop="name" label="字段" width="200px" />
                    <el-table-column prop="desc" label="描述" />
                </el-table>
                <el-divider content-position="left">watch节点描述</el-divider>
                <el-table border :data="DialogWatchTable">
                    <el-table-column prop="name" label="字段" width="200px" />
                    <el-table-column prop="desc" label="描述" />
                </el-table>
            </el-card>

            <el-card shadow="hover">
                <label slot="header">DrawerMixins抽屉/侧滑混入</label>
                <el-divider content-position="left">data节点描述 表格中包含（=）的参数可于其他混入参数重复，并非冗余，而是考虑多变的使用环境做的兼容处理，重复对象会被做合并属性处理</el-divider>
                <el-table border :data="DrawerDataTable">
                    <el-table-column prop="name" label="字段" width="200px" />
                    <el-table-column prop="desc" label="描述" />
                </el-table>
                <el-divider content-position="left">methods节点描述</el-divider>
                <el-table border :data="DrawerMethodsTable">
                    <el-table-column prop="name" label="字段" width="200px" />
                    <el-table-column prop="desc" label="描述" />
                </el-table>
                <el-divider content-position="left">watch节点描述</el-divider>
                <el-table border :data="DrawerWatchTable">
                    <el-table-column prop="name" label="字段" width="200px" />
                    <el-table-column prop="desc" label="描述" />
                </el-table>
            </el-card>

            <el-card shadow="hover">
                <label slot="header">Validator表单校验方法混入</label>
                <el-divider content-position="left">常用校验，结合规则使用方式，列：idCard: { required: true, validator: this.idCardValidator, trigger: ['blur', 'change'] }</el-divider>
                <el-table border :data="ValidatorMethodsTable">
                    <el-table-column prop="name" label="字段" width="200px" />
                    <el-table-column prop="desc" label="描述" />
                </el-table>
            </el-card>

            <el-card shadow="hover">
                <label slot="header">RealPeopleMixins实有人口填充交互混入</label>
                <el-divider content-position="left">data节点描述 表格中包含（=）的参数可于其他混入参数重复，并非冗余，而是考虑多变的使用环境做的兼容处理，重复对象会被做合并属性处理</el-divider>
                <el-table border :data="RealPeopleDataTable">
                    <el-table-column prop="name" label="字段" width="200px" />
                    <el-table-column prop="desc" label="描述" />
                </el-table>
                <el-divider content-position="left">methods节点描述</el-divider>
                <el-table border :data="RealPeopleMethodsTable">
                    <el-table-column prop="name" label="字段" width="200px" />
                    <el-table-column prop="desc" label="描述" />
                </el-table>
                <el-divider content-position="left">watch节点描述</el-divider>
                <el-table border :data="RealPeopleWatchTable">
                    <el-table-column prop="name" label="字段" width="200px" />
                    <el-table-column prop="desc" label="描述" />
                </el-table>
            </el-card>
        </div>
    </j-page>
</template>

<script>
    import PageMixins from "../../components/JComponents/JPage/mixins/PageMixins";
    export default {
        name: "JMixinsDemo",
        mixins: [PageMixins],
        data() {
            return {
                PageDataTable: [
                    { name: 'submitLoad', desc: '按钮提交行为标识，防止按钮多次点击时，提交多次数据（=）' },
                    { name: 'tableLoading', desc: '表格加载动画标识，用于loading效果' },
                    { name: 'tableData', desc: 'el-table表格绑定数据' },
                    { name: 'tableSelection', desc: '当表格设置为可勾选状态时，用于记录当前勾选值得数组' },
                    { name: 'query', desc: '查询筛选参数集，默认包含页码、数量设置、总数（=）' },
                ],
                PageMethodsTable: [
                    { name: 'getDetailMetaData', desc: '当分页数据不满足编辑或详情时的数据填充时，可传入详情api地址，获取完整数据' },
                    { name: 'tableSelectionChange', desc: '表格勾选时用于数组记录勾选数据' },
                    { name: 'exportEvent', desc: '导出通用方法，可复制到具体业务混入中，重新定义api地址使用' },
                    { name: 'load', desc: '通用表格数据请求方法，可复制到具体业务混入中，重新定义api地址使用' },
                    { name: 'searchEvent', desc: '查询点击行为，默认将页码重置，并发起数据请求' },
                    { name: 'resetEvent', desc: '参数重置清空行为，并发起数据请求' },
                    { name: 'delEvent', desc: '表格数据的删除操作' },
                    { name: 'pageUpdate', desc: '更新页码方法，根据当前页码和总数计算是否更新' },
                ],
                PaginationDataTable: [
                    { name: 'pmxCount', desc: '页码最大显示数' },
                    { name: 'pmxLayout', desc: '页码显示元素，默认包含总数、上一页、具体页码数、下一页' },
                    { name: 'pmxSizes', desc: '当页码元素包含可选数量时，可以指定每页显示多少条' },
                    { name: 'pmxBackground', desc: '是否显示页码背景' },
                    { name: 'query', desc: '查询筛选参数集，默认包含页码、数量设置、总数（=）' },
                ],
                PaginationMethodsTable: [
                    { name: 'changePage', desc: '分页改变时，更改query中的页码参数，并发起数据请求' },
                    { name: 'sizeChange', desc: '改变每页显示数量litmit，并发起数据请求' }
                ],
                DialogDataTable: [
                    { name: 'curItem', desc: '当前操作数据的临时引用' },
                    { name: 'dgmxChangeProxy', desc: '监控当前弹窗数据是否发生变换，未改变则无需重复保存' },
                    { name: 'submitLoad', desc: '按钮提交行为标识，防止按钮多次点击时，提交多次数据（=）' },
                    { name: 'dgmxFormLabelWidth', desc: '弹窗表单标题label的最大宽度，超过将被省略号代替' },
                    { name: 'showDgmx', desc: '显示弹窗标识' },
                    { name: 'showDgmxDetail', desc: '显示详情弹窗标识' },
                    { name: 'dgmxType', desc: '弹窗操作类型默认包括，新增ADD、编辑EDIT、详情DET' },
                    { name: 'dgmxTypeMap', desc: '根据不同的操作类型，显示不同的弹窗标题映射对象' },
                    { name: 'dgmxForm', desc: '弹窗数据对象，具体定义到具体的业务混入中' },
                    { name: 'dgmxRule', desc: '弹窗校验规则，具体定义到具体的业务混入中' },
                ],
                DialogMethodsTable: [
                    { name: 'detailDgmxEvent', desc: '显示弹窗详情，获取详情数据，并显示' },
                    { name: 'editDgmxEvent', desc: '编辑弹窗，获取详情数据，并显示' },
                    { name: 'addDgmxEvent', desc: '新建弹窗数据，显示初始化dgmxForm的内容' },
                    { name: 'checkDgmxProxy', desc: '校验数据是否变动' },
                    { name: 'proxyDgmxData', desc: '绑定原始数据，以便校验数据变动' },
                    { name: 'checkDgmxEvent', desc: '按照定义的规则，对弹窗表单数据进行校验' },
                    { name: 'saveDgmxData', desc: '保存弹窗数据，根据dgmxType的不同，判断是新增还是编辑，需要复制该方法，在具体的业务混入中替换接口使用' },
                ],
                DialogWatchTable: [
                    { name: 'showDgmx', desc: '观察showDgmx标识，当弹窗关闭时，将数据校验，及弹窗对象初始化' },
                ],
                DrawerDataTable: [
                    { name: 'curItem', desc: '当前操作数据的临时引用' },
                    { name: 'drmxChangeProxy', desc: '监控当前弹窗数据是否发生变换，未改变则无需重复保存' },
                    { name: 'submitLoad', desc: '按钮提交行为标识，防止按钮多次点击时，提交多次数据（=）' },
                    { name: 'drmxFormLabelWidth', desc: '弹窗表单标题label的最大宽度，超过将被省略号代替' },
                    { name: 'showDrmx', desc: '显示弹窗标识' },
                    { name: 'showDrmxDetail', desc: '显示详情弹窗标识' },
                    { name: 'drmxType', desc: '弹窗操作类型默认包括，新增ADD、编辑EDIT、详情DET' },
                    { name: 'drmxTypeMap', desc: '根据不同的操作类型，显示不同的弹窗标题映射对象' },
                    { name: 'drmxForm', desc: '弹窗数据对象，具体定义到具体的业务混入中' },
                    { name: 'drmxRule', desc: '弹窗校验规则，具体定义到具体的业务混入中' },
                ],
                DrawerMethodsTable: [
                    { name: 'detailDrmxEvent', desc: '显示弹窗详情，获取详情数据，并显示' },
                    { name: 'editDrmxEvent', desc: '编辑弹窗，获取详情数据，并显示' },
                    { name: 'addDrmxEvent', desc: '新建弹窗数据，显示初始化drmxForm的内容' },
                    { name: 'checkDrmxProxy', desc: '校验数据是否变动' },
                    { name: 'proxyDrmxData', desc: '绑定原始数据，以便校验数据变动' },
                    { name: 'checkDrmxEvent', desc: '按照定义的规则，对弹窗表单数据进行校验' },
                    { name: 'saveDrmxData', desc: '保存弹窗数据，根据drmxType的不同，判断是新增还是编辑，需要复制该方法，在具体的业务混入中替换接口使用' },
                ],
                DrawerWatchTable: [
                    { name: 'showDrmx', desc: '观察showDrmx标识，当弹窗关闭时，将数据校验，及弹窗对象初始化' },
                ],
                ValidatorMethodsTable: [
                    { name: 'idCardValidator', desc: '身份证号码有效性校验' },
                    { name: 'phoneValidator', desc: '手机号校验' },
                    { name: 'telValidator', desc: '座机电话校验' },
                    { name: 'emailValidator', desc: '邮箱校验' },
                    { name: 'ageValidator', desc: '年龄校验，包含数值类型及18岁校验，可根据业务复制修改' },
                    { name: 'passValidator', desc: '密码重复确认框校验' },
                ],
                RealPeopleDataTable: [
                    { name: 'lockInfo', desc: '数据自动填充后，哪些字段无法编辑修改' },
                    { name: 'baseInfo', desc: '需要获取的实有人口字段值，将从完整的人口数据中筛选出，需要的字段' },
                    { name: 'realPeopleKeyword', desc: '实有人口自动填充搜索关键字' },
                ],
                RealPeopleMethodsTable: [
                    { name: 'queryRealPeople', desc: '根据接口查询并显示实有人口列表数据，默认显示姓名-性别的组合用以区分' },
                    { name: 'selectRealPeople', desc: '选择人口后的具体操作，默认填充至表单对象中' }
                ],
                RealPeopleWatchTable: [
                    { name: 'showDrmx/showDgmx', desc: '关闭弹窗/抽屉时，需要将搜索关键字和锁定信息清空' },
                ]
            }
        },
        created() {

        },
        methods: {}
    }
</script>

<style>
    .el-card {
        position: relative;
        margin-bottom: 50px;
    }
</style>
